import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/common/button';
import ServiceDetail from 'modules/page/landing/ServiceDetail';
import { cryptojs } from 'helpers';
import moment from 'moment';
import IconConfigWithTheme from 'components/common/icon-config-with-theme';
import useAuth from 'hooks/useAuth';
import type { DataEncodeURLProps } from 'types';
import ServiceSymstom from 'modules/page/landing/ServiceSymstom';
import ServiceMethod from 'modules/page/landing/ServiceMethod';
import ServicePharmacyNearby from 'modules/page/landing/ServicePharmacyNearby';
import ServiceRating from 'modules/page/landing/ServiceRating';
import ServiceQeustionAndAnswer, { QeustionBox } from 'modules/page/landing/ServiceQnA';
import ServiceRelate from 'modules/page/landing/ServiceRelate';
import LandingLogin from 'modules/page/landing/LandingLogin';
import MetaTags from 'react-meta-tags';

function TLPConsultServiceLanding() {
    const refs = useRef(null);
    const navigate = useNavigate();
    const { auth } = useAuth();
    const timer = useRef<NodeJS.Timeout>();
    const [showMethod, setShowMethod] = useState(1);

    const params = useMemo(() => {
        const origin = window.location.origin;
        return origin.includes('fastcare.co') ? '?voucher=fastcare01' : '?voucher=TLPCONSULT';
    }, [window.location.origin]);

    const onNextPage = () => {
        let path = process.env.REACT_APP_LIFF_REDIRECT_DEFAULT;
        let dataForEncode: DataEncodeURLProps = {
            path: '/telepharmacy/claim',
            params: window.location.search || '?voucher=TLPCONSULT&fromService=true',
            data: {
                authorization: null,
                userId: null,
                autoLogin: 0,
            },
        };
        if (window.location.origin.includes('fastcare.co')) {
            path = process.env.REACT_APP_LIFF_REDIRECT_FASTCARE;
            dataForEncode = {
                ...dataForEncode,
                params: window.location.search || '?voucher=fastcare01&fromService=true',
                data: {
                    authorization: null,
                    userId: null,
                    autoLogin: 0,
                    partner: '18',
                },
            };
        }

        const encode = cryptojs.encode(dataForEncode);
        if (auth.isAuth) {
            return navigate(dataForEncode.path + dataForEncode.params);
        }
        return window.location.assign(path + '?to=' + encode);
    };

    const onChangeMethod = (method: number) => {
        let _method = method;

        clearInterval(timer.current);
        setShowMethod(_method);

        timer.current = setInterval(() => {
            _method++;

            if (_method < 4) {
                setShowMethod(_method);
            } else {
                setShowMethod(1);
                _method = 1;
            }
        }, 5000);
    };

    const onContinueService = () => {
        let path = process.env.REACT_APP_LIFF_REDIRECT_DEFAULT;
        let dataForEncode: DataEncodeURLProps = {
            path: '/telepharmacy/claim',
            params: window.location.search || '?voucher=TLPCONSULT&fromService=true',
            data: {
                authorization: null,
                userId: null,
                autoLogin: 0,
            },
        };
        if (window.location.origin.includes('fastcare.co')) {
            path = process.env.REACT_APP_LIFF_REDIRECT_FASTCARE;
            dataForEncode = {
                ...dataForEncode,
                params: window.location.search || '?voucher=fastcare01&fromService=true',
                data: {
                    authorization: null,
                    userId: null,
                    autoLogin: 0,
                    partner: '18',
                },
            };
        }

        const encode = cryptojs.encode(dataForEncode);
        if (auth.isAuth) {
            return dataForEncode.path + dataForEncode.params;
        }
        return path + '?to=' + encode;
    };

    useEffect(() => {
        onChangeMethod(1);

        return () => clearInterval(timer.current);
    }, []);

    return (
        <>
            <MetaTags>
                <meta name='keywords' content='ซื้อยา ออนไลน์' />
            </MetaTags>
            <ServiceDetail>
                <div className='landing-service'>
                    <div className='service-panel service-content pb-0'>
                        <div className='title'>บริการ</div>
                        <h1 className='sub-title'>ปรึกษาเภสัชกร</h1>
                        <h4 className='detail'>
                            <div>ปรึกษาอาการกับเภสัชกรคุณภาพ </div>
                            <div>พร้อมบริการจัดส่งยาถึงบ้าน</div>
                        </h4>
                        <div className='service-image mb-0'>
                            <img src='/images/service-landing/service-tlp-consult-desktop.webp' className='desktop' alt='desktop' />
                            <img src='/images/service-landing/service-tlp-consult-mobile.webp' className='mobile' alt='mobile' />
                        </div>
                    </div>
                    <div className='service-panel service-detail'>
                        <h3 className='title'>รายละเอียดบริการ</h3>
                        <div className='detail'>
                            <div className='icon'>
                                <IconConfigWithTheme pageName='landing1_tlp_consult' iconName='sevice_detail_1' />
                            </div>
                            <h4>ให้บริการ 10.00-20.00 น. ทุกวัน</h4>
                        </div>
                        <div className='detail'>
                            <div className='icon'>
                                <IconConfigWithTheme pageName='landing1_tlp_consult' iconName='sevice_detail_2' />
                            </div>
                            <h4>ให้คำแนะนำ เรื่อง ยา อาการเบื้องต้น หรือ การเปลี่ยนพฤติกรรมโดยเภสัชกรคุณภาพ พร้อมบริการจัดส่งถึงบ้าน</h4>
                        </div>
                        <div className='detail'>
                            <div className='icon'>
                                <IconConfigWithTheme pageName='landing1_tlp_consult' iconName='dalivery_time' />
                            </div>
                            <h4>ระยะเวลาจัดส่งประมาณ 2-3 ชม.</h4>
                        </div>
                        <h3 className='title'>อัตราค่าบริการ</h3>
                        <div className='sevice-rate-panel'>
                            <div className='sevice-rate'>
                                <div className='list'>
                                    <div className='list-icon'>
                                        <IconConfigWithTheme pageName='landing1_tlp_consult' iconName='service_rate' />
                                    </div>
                                    <div className='list-content'>
                                        <h3 className='list-title'>ค่าบริการทางเภสัชกรรม</h3>
                                        <h4 className='list-detail'>
                                            <span>50 บาท </span>
                                            <div>(*หากไม่มีการซื้อยา)</div>
                                        </h4>
                                    </div>
                                </div>
                                <div className='list'>
                                    <div className='list-icon'>
                                        <IconConfigWithTheme pageName='landing1_tlp_consult' iconName='medicine_rate' />
                                    </div>
                                    <div className='list-content'>
                                        <h3 className='list-title'>ค่ายา</h3>
                                        <h4 className='list-detail'>
                                            <span>ราคาตามหน้าร้านยา</span>
                                            <div>(ถ้ามี)</div>
                                        </h4>
                                    </div>
                                </div>
                                <div className='list'>
                                    <div className='list-icon'>
                                        <IconConfigWithTheme pageName='landing1_tlp_consult' iconName='dalivery_rate' />
                                    </div>
                                    <div className='list-content'>
                                        <h3 className='list-title'>ค่าจัดส่ง</h3>
                                        <h4 className='list-detail'>
                                            <div className='line-nomal'>เริ่มต้นที่ 57 บาท</div>
                                            <div>(ฟรีค่าจัดส่ง ตั้งแต่วันนี้ถึง {moment('2565-09-30').format('D MMM YYYY')})</div>
                                        </h4>
                                    </div>
                                </div>
                                <div className='list'>
                                    <div className='list-icon'>
                                        <IconConfigWithTheme pageName='landing1_tlp_consult' iconName='management_rate' />
                                    </div>
                                    <div className='list-content'>
                                        <h3 className='list-title'>ค่าธรรมเนียมการจัดการ</h3>
                                        <h4 className='list-detail'>
                                            <div className='line-through'>55 บาท </div>
                                            <div>(*ฟรีค่าธรรมเนียมในเดือนเมษายน-ธันวาคม 2565)</div>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className='panel-footer' ref={refs}>
                                <Button variant='info' onClick={() => onNextPage()}>
                                    ปรึกษาเภสัชกรตอนนี้
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='consult-now'>
                    <div className='custom-btn'>
                        <Button variant='info' id='myBtn' onClick={() => onNextPage()}>
                            ปรึกษาเภสัชกรตอนนี้
                        </Button>
                    </div>
                </div>
            </ServiceDetail>
            <ServiceSymstom imageBgc='orange'>
                <div className='landing-panel'>
                    <div className='landing-icon'>
                        <img src='/images/service-landing/pharmcare-short-logo.svg' alt='pharmcare-icon' />
                    </div>
                    <h2>
                        <div className='title'>อาการเบื้องต้น</div>
                        <div className='sub-title'>ที่เภสัชกรของเราให้คำปรึกษา</div>
                    </h2>
                    <div className='landing-content'>
                        <div className='landing-image'>
                            <img src='/images/service-landing/symptoms-tlp-consult.webp' alt='symptoms' />
                        </div>
                        <div className='symptoms'>
                            <div className='symptoms-about'>อาการเกี่ยวกับ...</div>
                            <ul className='symptoms-list'>
                                <li>
                                    <h4>ยาคุม</h4>
                                </li>
                                <li>
                                    <h4>วิธีการใช้ยา</h4>
                                </li>
                                <li>
                                    <h4>อาการเบื้องต้น</h4>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </ServiceSymstom>
            <ServiceMethod>
                <div className='landing-panel'>
                    <h3 className='title'>ขั้นตอนในการรับบริการ</h3>
                    <div className='method'>
                        <div className='method-row mark-1'>
                            <div className='method-row mark-2'>
                                <div className='method-col'>
                                    <div
                                        className={showMethod === 1 ? 'method-title active' : 'method-title'}
                                        onClick={() => onChangeMethod(1)}
                                    >
                                        <div className='circle'>1</div>
                                        <h3>ปรึกษาเภสัชกร</h3>
                                    </div>
                                </div>
                                <div className='method-col'>
                                    <div
                                        className={showMethod === 2 ? 'method-title active' : 'method-title'}
                                        onClick={() => onChangeMethod(2)}
                                    >
                                        <div className='circle'>2</div>
                                        <h3>จ่ายยาตามอาการ</h3>
                                    </div>
                                </div>
                                <div className='method-col'>
                                    <div
                                        className={showMethod === 3 ? 'method-title active' : 'method-title'}
                                        onClick={() => onChangeMethod(3)}
                                    >
                                        <div className='circle'>3</div>
                                        <h3>รอรับยา</h3>
                                    </div>
                                </div>
                            </div>
                            <div className='method-row mark-3 line-center'>
                                <div className={showMethod === 1 ? 'method-col active' : 'method-col'}>
                                    <div className='method-image'>
                                        <img src='/images/service-landing/method-1.webp' alt='method-1' />
                                    </div>
                                </div>
                                <div className={showMethod === 2 ? 'method-col active' : 'method-col'}>
                                    <div className='method-image'>
                                        <img src='/images/service-landing/method-2.webp' alt='method-2' />
                                    </div>
                                </div>
                                <div className={showMethod === 3 ? 'method-col active' : 'method-col'}>
                                    <div className='method-image'>
                                        <img src='/images/service-landing/method-3.webp' alt='method-3' />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='method-row'>
                            <div className={showMethod === 1 ? 'method-col active' : 'method-col'}>
                                <div className='method-detail'>
                                    <div className='method-title'>
                                        <div>1. ปรึกษาเภสัชกร</div>
                                    </div>
                                    <p>กรอกข้อมูลสุขภาพ อาการของคุณ และเริ่มต้นสนทนากับเภสัชกร ภายใน 5 นาที</p>
                                </div>
                            </div>
                            <div className={showMethod === 2 ? 'method-col active' : 'method-col'}>
                                <div className='method-detail'>
                                    <div className='method-title'>
                                        <div>2. จ่ายยาตามอาการ</div>
                                    </div>
                                    <p>หากต้องการรับยา เภสัชกรจะจัดยาตามอาการเบื้องต้นให้คุณ</p>
                                </div>
                            </div>
                            <div className={showMethod === 3 ? 'method-col active' : 'method-col'}>
                                <div className='method-detail'>
                                    <div className='method-title'>
                                        <div>3. รอรับยา</div>
                                    </div>
                                    <p>ยืนยันรายการ ที่อยู่จัดส่ง เพื่อรอรับยาพร้อมติดตามสถานะแบบเรียลไทม์</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ServiceMethod>
            <ServicePharmacyNearby serviceLink={onContinueService()} />
            <ServiceRating>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>เภสัชกรอธิบายวิธีใช้ยาละเอียดเหมือนไปรับบริการที่ร้านยาจริงๆเลยครับ</div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlp_consult' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>เจ</div>
                            <div className='rating-date'>27 May 2020</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>ได้รับยารวดเร็วมากเลยค่ะ สะดวกสบาย ไม่ต้องเสียเวลาเดินทางไปที่ร้านยา</div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlp_consult' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>เกณิกา</div>
                            <div className='rating-date'>27 May 2020</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            วันนั้นไม่สบาย อยู่คอนโดคนเดียว เลยเลือกใช้บริการ เภสัชกรอธิบายโรคดีมาก ทำให้ทราบว่าต้องทำอย่างไร ขอบคุณมาก ๆ
                            เลยครับ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlp_consult' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>ไมค์ </div>
                            <div className='rating-date'>27 May 2020</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>ขอบคุณพี่เภสัชที่ทำให้ทราบว่ายาที่ใช้อยู่ประจำ ทำให้ปวดท้องได้</div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlp_consult' iconName='star' />

                            <span>4</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>ญาตา</div>
                            <div className='rating-date'>27 May 2020</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            ตอนแรกตั้งใจจะซื้อยาเดิมที่เคยใช้ โชคดีที่วันนั้นกดใช้บริการนี้
                            เภสัชกรอธิบายทำให้ทราบว่าหากใช้ยาเดิมอาการจะแย่ลง ตอนนี้หายแล้ว ขอบคุณเภสัชกรมากค่ะ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlp_consult' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>ชาคริยา</div>
                            <div className='rating-date'>27 May 2020</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>ประทับใจ ตรงที่มีการแนบคำแนะนำการปฏิบัติตัวมาให้อ่านด้วย</div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlp_consult' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>ธัญมล</div>
                            <div className='rating-date'>27 May 2020</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            คุณแม่ท้องเสีย ไม่มีรถไปร้านยา เลยกดใช้บริการ หลังจากนั้นรอไม่นานคุณแม่ก็ได้รับยา ไม่งั้นวันนั้นคงกังวลมากค่ะ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlp_consult' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>ธีรยา</div>
                            <div className='rating-date'>27 May 2020</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            ชอบมากเลยครับ ไม่ต้องออกไปเสี่ยงโควิดที่ร้านยา รอประมาณชั่วโมงกว่า ๆ ก็ได้รับยาแล้ว
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlp_consult' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>วิน</div>
                            <div className='rating-date'>27 May 2020</div>
                        </div>
                    </div>
                </div>
            </ServiceRating>
            <ServiceQeustionAndAnswer>
                <div className='landing-panel'>
                    <h2 className='title'>คำถามที่พบบ่อย</h2>
                    <div className='landing-content'>
                        <div className='landing-image'>
                            <img src='/images/service-landing/question.webp' alt='question' />
                        </div>
                        <div className='question-n-answer'>
                            <QeustionBox question={'1. มีบริการในจังหวัดใดบ้าง'}>บริการเราสามารถใช้ได้ทุกจังหวัดทั่วประเทศไทย</QeustionBox>
                            <QeustionBox question={'2. ค่าจัดส่งคิดอย่างไร'}>
                                <p>ฟรีค่าจัดส่ง ตั้งแต่วันนี้ถึง {moment('2565-09-30').format('D MMM YYYY')}</p>
                                {/* <>
                                    <p>
                                        เขตกทม.และปริมณฑล คิดค่าบริการ 57 บาท สำหรับ 1 กิโลเมตรแรก และเพิ่ม 7 บาท สำหรับทุกๆ 1 กิโลเมตรถัดไป
                                        ซึ่งจะได้รับยาภายใน 3 ชั่วโมง
                                    </p>
                                    <div>สำหรับต่างจังหวัด คิดค่าจัดส่ง 80 บาท และจะได้รับยาภายใน 1-3 วัน</div>
                                </> */}
                            </QeustionBox>
                            <QeustionBox question={'3. ใช้เวลาจัดส่ง นานเท่าไหร่'}>
                                <p>สำหรับบริการจัดส่งยาในเขตกทมและปริมณฑล คนไข้จะได้รับยาภายใน 3 ชม</p>
                                <div>
                                    ยกเว้นรหัสไปรษณีย์ (10280, 10550, 10560, 10570, 11150, 12110, 12170, 74120, 74130) ใช้เวลาจัดส่ง 1-3 วัน
                                </div>
                                <div>สำหรับบริการจัดส่งยาในต่างจังหวัด คนไข้จะได้รับยาภายใน 1-3 วัน</div>
                            </QeustionBox>
                            <QeustionBox question={'4. ช่วงเวลาเปิดให้บริการ คือช่วงใด'}>10:00-20:00 ทุกวัน</QeustionBox>
                            <QeustionBox question={'5. ราคายาเท่าไหร่'}>
                                ราคายา เป็นราคาเดียวกับที่ลูกค้ามาซื้อหน้าร้าน ของแต่ละร้าน (ไม่บวกเพิ่ม)
                            </QeustionBox>
                            <QeustionBox question={'6. มียาอะไรบ้าง'}>
                                <p>รายการยาที่มีจะเหมือนที่จำหน่ายหน้าร้านขายยา แต่ละร้าน</p>
                            </QeustionBox>
                            <QeustionBox question={'7. โทรเข้ามาปรึกษาหรือถามอาการ โดยไม่ซื้อยาได้ไหม'}>
                                สำหรับบริการที่มีการปรึกษาเภสัชกรโดยไม่มีการซื้อยา อาจมีค่าบริการทางเภสัชกรรม 50 บาท
                                (ขึ้นอยู่กับเภสัชกรผู้ให้บริการ)
                            </QeustionBox>
                            <QeustionBox question={'8. เราปรึกษาเภสัชกรผ่านช่องทางใด'}>สนทนาผ่าน video call ผ่านระบบ Pharmcare</QeustionBox>
                            <QeustionBox question={'9. ถ้าต้องการซื้อยาเฉยๆ จำเป็นต้องปรึกษากับเภสัชกรไหม'}>
                                เภสัชกรจะพิจารณาจ่ายยาตามอาการ และความเหมาะสมสำหรับผู้ป่วยแต่ละราย
                                จึงจำเป็นต้องปรึกษาเภสัชกรก่อนซื้อยาทุกครั้ง
                            </QeustionBox>
                            <QeustionBox question={'10. ชำระเงินผ่านช่องทางใดได้บ้าง'}>
                                สามารถชำระด้วยบัตรเครดิต/เดบิท หรือ โอนเงินผ่านธนาคารโดยใช้ Promptpay
                            </QeustionBox>
                            <QeustionBox question={'11. มีบริการเก็บเงินปลายทางหรือไม่'}>ไม่มีค่ะ</QeustionBox>{' '}
                        </div>
                    </div>
                </div>
            </ServiceQeustionAndAnswer>
            <ServiceRelate serviceList={['telemed', 'storeNearby']} />
            <LandingLogin onNextPath={'/telepharmacy/claim'} params={params} />
        </>
    );
}

export default TLPConsultServiceLanding;
